import styled from "styled-components";

export const Row = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.8rem;
	overflow: hidden;
`;

export const IconBadgeContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const CountBadge = styled.span<{ $hasAlerts: boolean }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	min-width: 1.8rem;
	height: 1.8rem;
	padding: 0 0.5rem;
	border-radius: 999px;
	font-size: 1.1rem;
	font-weight: 700;
	line-height: 1;
	border: 0.1rem solid ${({ $hasAlerts }) => ($hasAlerts ? "#D60D25" : "#95999A")};
	background: ${({ $hasAlerts }) => ($hasAlerts ? "#FDECEC" : "#F0F0F0")};
	color: ${({ $hasAlerts }) => ($hasAlerts ? "#B00A1E" : "#5C5F60")};
`;

export const CollapsedCountBadge = styled(CountBadge)`
	position: absolute;
	bottom: -0.3rem;
	right: -0.5rem;
	min-width: 1.6rem;
	height: 1.6rem;
	padding: 0 0.3rem;
	font-size: 1rem;
	border-width: 0.15rem;
	border-color: ${({ theme }) => theme.colors.appBlack};
	box-sizing: border-box;
`;
